import { Component, Input } from '@angular/core';
import { IPagedList } from '@brafton/common-framework-library';

@Component({
  selector: 'shared-filter-results-count',
  templateUrl: './filter-results-count.component.html',
  styleUrls: ['./filter-results-count.component.scss'],
  host: { class: 'shared-filter-results-count' },
})
export class SharedFilterResultsCountComponent {
  @Input() results!: IPagedList<any>
  @Input() filtered = false;
  @Input() objectName = 'Projects';

}
